import { render, staticRenderFns } from "./MyRadioButton.vue?vue&type=template&id=3a51414e&scoped=true"
import script from "./MyRadioButton.vue?vue&type=script&lang=js"
export * from "./MyRadioButton.vue?vue&type=script&lang=js"
import style0 from "./MyRadioButton.vue?vue&type=style&index=0&id=3a51414e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51414e",
  null
  
)

export default component.exports